export default "__VITE_ASSET__5804c6eb__"